import React, { Component } from 'react';
import {connect} from 'react-redux';
import {Icon} from "@blueprintjs/core";
import {List} from "immutable";
import numeral from 'numeral';
import Modal from "@atlaskit/modal-dialog/dist/esm/components/Modal";

// Components
import VirtualizedTable from "../../components/common/virtualized-table";
import AddMaterialDialog from "../../components/dialogs/AddMaterialDialog";
import EditMaterialDialog from '../../components/dialogs/EditMaterialDialog';

// Actions
import {getMaterials, createMaterial, deleteMaterial, cleanMaterials} from "../../actions/materials";
import {registerMovement, updateMovement} from "../../actions/movement";

// Numeral configuration
import 'numeral/locales/es-es'
numeral.locale('es-es');
numeral.defaultFormat('0,0.00 $');

class ProjectMaterials extends Component {
    constructor(props) {
        super(props);

        this.getProjectMaterials();

        this.state = {
            canSubmit: false,
            modalIsOpen: false,
            modalType: null,
            editMaterial: {}
        }
    }
    componentWillUnmount() {
        this.props.cleanMaterials();
    }

    getProjectMaterials = () => {
        this.props.getMaterials({
            project: this.props.project.get('_id')
        });
    };

    onCanSubmit = (canSubmit) => {
        this.setState({
            canSubmit
        });
    };

    // Modal Handlers
    openModal = (modalType) => {
        this.setState({
            modalType,
            modalIsOpen: true
        });
    };
    closeModal = () => {

        this.setState({
            modalType: null,
            modalIsOpen: false,
            canSubmit: false
        });
    };

    render() {
        // Material costs
        let material_costs = 0;
        this.props.materials.forEach( material => {
            material_costs = material_costs + material.get('cost');
        });

        // Materials to project Table
        let materialsToProjectTableSettings = {
            sortable: true,
            filterable: true,
            defaultSortFields: [],
            defaultSortDirections: ['asc'],
            height: 240,
            rowHeight: 55,
            strippedRows: false,
        };
        let materialsToProjectTableData = this.props.materials || List([]);
        materialsToProjectTableData = materialsToProjectTableData.filter(material => {
            return material.getIn(['movement', 'destination_type']) === 'Project'
        });
        let materialsToProjectTableColumns = {
            product: {
                title: 'Producto',
                columnType: 'text',
                dataField: 'product.name',
                width: 200,
                style: {},
                sortable: true,
                filterable: true
            },
            desc: {
                title: 'Comentario',
                columnType: 'text',
                dataField: 'comment',
                width: 100,
                style: {},
                sortable: true,
                filterable: true
            },
            amount: {
                title: "Cantidad",
                columnType: 'number',
                dataField: 'amount',
                width: 80,
                style: {textAlign: 'right'},
                sortable: true,
                filterable: true,
                format: '0.[00000]'
            },
            price: {
                title: "Precio (€)",
                columnType: 'number',
                dataField: 'price',
                width: 80,
                style: { textAlign: 'right' },
                sortable: true,
                filterable: true,
            },
            discount: {
                title: "Descuento %",
                columnType: 'function',
                dataField: 'discount',
                width: 80,
                style: { textAlign: 'right' },
                sortable: true,
                filterable: true,
                nodeContent: (value) => {
                    return <div>
                        <span>
                            {value || 0} %
                        </span>
                    </div>
                }
            },
            cost: {
                title: "Total (€)",
                columnType: 'number',
                dataField: 'cost',
                width: 80,
                style: {textAlign: 'right'},
                sortable: true,
                filterable: true
            },
            origin: {
                title: "Añadido desde",
                columnType: 'text',
                dataField: 'movement.origin_id.name',
                width: 80,
                style: {},
                sortable: true,
                filterable: true
            },
            added_date: {
                title: "Fecha de añadido",
                columnType: 'date',
                dataField: 'createdAt',
                width: 80,
                style: {},
                sortable: true,
                filterable: true,
                format: 'DD/MM/YYYY'
            },
            edit: {
                title: '',
                columnType: 'function',
                dataField: ['_id', 'product._id', 'product.name', 'amount', 'price', 'discount', 'movement', 'comment'],
                width: 30,
                style: { alignItems: 'center', maxWidth: 30 },
                sortable: false,
                filterable: false,
                nodeContent: (value) => {
                    const materialData = {
                        material_id: value[0],
                        product_id: value[1],
                        name: value[2],
                        amount: value[3],
                        price: value[4],
                        discount: value[5],
                        movement: value[6],
                        comment: value[7]
                    }
                    return (
                        <Icon
                            className='cursor-pointer'
                            icon='edit'
                            title='Editar'
                            iconSize={18}
                            onClick={() => {
                                this.setState({ editMaterial: materialData })
                                this.openModal('editMaterial');
                            }}
                        />
                    )
                }
            },
            actions: {
                title: '',
                columnType: 'function',
                dataField: '_id',
                width: 30,
                style: { alignItems: 'center', maxWidth: 30 },
                sortable: false,
                filterable: false,
                nodeContent: (materialId) => {
                    return (
                        <Icon
                            className="cursor-pointer"
                            icon="trash"
                            title="Eliminar"
                            iconSize={18}
                            onClick={ () => this.props.deleteMaterial(materialId) }
                        />
                    );
                }
            }
        };

        // Materials from project Table
        let materialsFromProjectTableSettings = {
            sortable: true,
            filterable: true,
            defaultSortFields: [],
            defaultSortDirections: ['asc'],
            height: 240,
            rowHeight: 40,
            strippedRows: false,
        };
        let materialsFromProjectTableData = this.props.materials || List([]);
        materialsFromProjectTableData = materialsFromProjectTableData.filter(material => {
            return material.getIn(['movement', 'origin_type']) === 'Project'
        });
        let materialsFromProjectTableColumns = {
            product: {
                title: 'Producto',
                columnType: 'text',
                dataField: 'product.name',
                width: 200,
                style: {},
                sortable: true,
                filterable: true
            },
            amount: {
                title: "Cantidad",
                columnType: 'number',
                dataField: 'amount',
                width: 100,
                style: {textAlign: 'right'},
                sortable: true,
                filterable: true,
                format: '0.[00000]'
            },
            origin: {
                title: "Enviado a",
                columnType: 'text',
                dataField: 'movement.destination_id.name',
                width: 100,
                style: {},
                sortable: true,
                filterable: true
            },
            added_date: {
                title: "Fecha de envío",
                columnType: 'date',
                dataField: 'createdAt',
                width: 100,
                style: {},
                sortable: true,
                filterable: true,
                format: 'DD/MM/YYYY'
            },
            actions: {
                title: '',
                columnType: 'function',
                dataField: '_id',
                width: 100,
                style: { alignItems: 'center', maxWidth: 30 },
                sortable: false,
                filterable: false,
                nodeContent: (materialId) => {
                    return (
                        <Icon
                            className="cursor-pointer"
                            icon="trash"
                            title="Eliminar"
                            iconSize={18}
                            onClick={ () => this.props.deleteMaterial(materialId) }
                        />
                    );
                }
            }
        };

        // Modal Area
        let modal = null;
        if (this.state.modalIsOpen) {
            switch (this.state.modalType) {
                case 'materialToProject':
                    modal = {
                        width: 'x-large',
                        title: 'Añadir material al proyecto',
                        body: (
                            <AddMaterialDialog
                                onRef={ref => (this.child = ref)}
                                materialTo="project"
                                project={this.props.project}
                                onCanSubmit={this.onCanSubmit}
                                onCloseModal={this.closeModal}
                                registerMovement={this.props.registerMovement}
                            />
                        ),
                        footer: (
                            <div className="modal-footer">
                                <button
                                    key="cancel"
                                    type="button"
                                    className="btn btn-cancel"
                                    label={'Cancelar'}
                                    style={{
                                        color: 'gray',
                                        marginRight: 15
                                    }}
                                    onClick={this.closeModal}
                                >
                                    {'Cancelar'}
                                </button>
                                <button
                                    key="accept"
                                    type="button"
                                    className="btn btn-primary"
                                    disabled={!this.state.canSubmit}
                                    onClick={ () => {
                                        this.child.onAddButtonClick();
                                    }}
                                >
                                    {'Guardar'}
                                </button>
                            </div>
                        )
                    };
                    break;
                case 'materialToWarehouse':
                    modal = {
                        width: 'large',
                        title: 'Añadir material al proyecto',
                        body: (
                            <AddMaterialDialog
                                materialTo="warehouse"
                                onRef={ref => (this.child = ref)}
                                project={this.props.project}
                                onCanSubmit={this.onCanSubmit}
                                onCloseModal={this.closeModal}
                                registerMovement={this.props.registerMovement}
                            />
                        ),
                        footer: (
                            <div className="modal-footer">
                                <button
                                    key="cancel"
                                    type="button"
                                    className="btn btn-cancel"
                                    label={'Cancelar'}
                                    style={{
                                        color: 'gray',
                                        marginRight: 15
                                    }}
                                    onClick={this.closeModal}
                                >
                                    {'Cancelar'}
                                </button>
                                <button
                                    key="accept"
                                    type="button"
                                    className="btn btn-primary"
                                    disabled={!this.state.canSubmit}
                                    onClick={ () => {
                                        this.child.onAddButtonClick();
                                    }}
                                >
                                    {'Añadir'}
                                </button>
                            </div>
                        )
                    };
                    break;
                case 'editMaterial':
                    modal = {
                        width: 'small',
                        title: 'Editar material',
                        body: (
                            <EditMaterialDialog 
                                onRef={ref => (this.child = ref)}
                                material={this.state.editMaterial}
                                onCanSubmit={this.onCanSubmit}
                                onCloseModal={this.closeModal}
                                updateMovement={this.props.updateMovement}
                            />
                        ),
                        footer: (
                            <div className="modal-footer">
                                <button
                                    key="cancel"
                                    type="button"
                                    className="btn btn-cancel"
                                    label={'Cancelar'}
                                    style={{
                                        color: 'gray',
                                        marginRight: 15
                                    }}
                                    onClick={this.closeModal}
                                >
                                    {'Cancelar'}
                                </button>
                                <button
                                    key="accept"
                                    type="button"
                                    className="btn btn-primary"
                                    disabled={!this.state.canSubmit}
                                    onClick={ () => {
                                        this.child.onAddButtonClick();
                                    }}
                                >
                                    {'Actualizar'}
                                </button>
                            </div>
                        )
                    }
                    break;
                default:
                    modal = {
                        title: '',
                        body: null,
                        footer: null
                    };
                    break;
            }
        }

        return (
            <div className="panel-body">
                <div className="row stats-zone" style={{ margin: '10px 0' }} >
                    <div className="col-auto">
                        <span className="label label-primary">{materialsToProjectTableData.size}</span>
                        <span>Materiales utilizados en el proyecto</span>
                    </div>
                    <div className="col-auto">
                        <span className="label label-danger">{ numeral(material_costs).format() }</span>
                        <span>Coste total de materiales</span>
                    </div>
                    <div className="col-auto ml-auto ">
                        <button
                            className="btn btn-primary"
                            onClick={ () => this.openModal('materialToProject') }
                        ><Icon icon="arrow-left" /> Añadir material</button>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <VirtualizedTable
                            tableSettings={materialsToProjectTableSettings}
                            tableColumns={materialsToProjectTableColumns}
                            tableData={materialsToProjectTableData}
                        />
                    </div>
                </div>
                <div className="row stats-zone" style={{ margin: '10px 0' }} >
                    <div className="col-auto">
                        <span className="label label-primary">{materialsFromProjectTableData.size}</span>
                        <span>Materiales generados en el proyecto</span>
                    </div>
                    <div className="col-auto ml-auto ">
                        <button
                            className="btn btn-primary"
                            onClick={ () => this.openModal('materialToWarehouse') }
                        ><Icon icon="arrow-right" /> Añadir material</button>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <VirtualizedTable
                            tableSettings={materialsFromProjectTableSettings}
                            tableColumns={materialsFromProjectTableColumns}
                            tableData={materialsFromProjectTableData}
                        />
                    </div>
                </div>
                { this.state.modalIsOpen && (
                    <Modal
                        width={modal.width}
                        heading={modal.title}
                        footer={() => modal.footer}
                        autoFocus={false}
                        onClose={this.closeModal}
                    >
                        {modal.body}
                    </Modal>
                )}
            </div>
        );
    }
}

const mapStateToProps = state => {
    // Reducers
    const materialsReducer = state.materials;
    // const movementReducer = state.movement;

    // Materials
    const materials = materialsReducer.get('payload') || List([]);

    return {
        materials
    }
};

const mapDispatchToProps = dispatch => {
    return {
        getMaterials: query => dispatch(getMaterials(query)),
        createMaterial: workReports => dispatch(createMaterial(workReports)),
        deleteMaterial: workReportId => dispatch(deleteMaterial(workReportId)),
        registerMovement: (movement) => dispatch(registerMovement(movement)),
        updateMovement: (movement) => dispatch(updateMovement(movement)),
        cleanMaterials: () => dispatch(cleanMaterials())
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ProjectMaterials);



// WEBPACK FOOTER //
// ./src/containers/projects/ProjectMaterials.js